// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"795":"2d84a710","2431":"a1cda92a","6840":"a1cda92a","7392":"ab5cb27c","8096":"a1cda92a","9680":"a1cda92a"}[chunkId] + ".chunk.css";
};